import React, { act, useState } from "react";
import { Button } from "semantic-ui-react";
import './Crossword.css';

const CrosswordKeyboard = ({ onKeyPress }) => {
    const firstRowLetters = 'QWERTYUIOP'.split('');
    const secondRowLetters = 'ASDFGHJKL'.split('');
    const thirdRowLetters = '-ZXCVBNM'.split('');

    return (
        <div className="keyboard">
            <div className="keyboardRow">
                {firstRowLetters.map((letter) => (
                    <button key={letter} onClick={() => onKeyPress(letter)}>
                        {letter}
                    </button>
                ))}
            </div>
            <div className="keyboardRow">
                {secondRowLetters.map((letter) => (
                    <button key={letter} onClick={() => onKeyPress(letter)}>
                        {letter}
                    </button>
                ))}
            </div>
            <div className="keyboardRow">
                {thirdRowLetters.map((letter) => (
                    <button key={letter} onClick={() => onKeyPress(letter)}>
                        {letter}
                    </button>
                ))}
                <button onClick={() => onKeyPress('Backspace')}>⌫</button>
            </div>
        </div>
    );
};

export default CrosswordKeyboard;